<div>
    <ion-input
        class="item-bg"
        (ionBlur)="stateChange($event)"
        (ionFocus)="stateChange($event)"
        [(ngModel)]="selectedValue"
        [placeholder]="placeholder"
        (ionInput)="filterAutodeclaration($event)"
    ></ion-input>

    @if(showList){
    <ion-list>
        <ion-item [id]="'autocomplete-input' + i" button *ngFor="let item of list; let i = index" (click)="selectAutodeclaration(item)">
            {{ item[listAttributeName] }}
        </ion-item>
    </ion-list>
    }
</div>
